import React from "react";

const OrderDetails = ({ order, close, setRefresh }) => {
  const extractUser = (orderData) => {
    const details = orderData?.user_details || {};
    const rawUser = orderData?.user || orderData?.user_id || "";
    const parts = typeof rawUser === "string" ? rawUser.split("-") : [];

    return {
      name:
        details?.name ||
        details?.full_name ||
        orderData?.notes?.name ||
        parts[0] ||
        "Not available",

      email:
        details?.email ||
        orderData?.notes?.email ||
        parts[1] ||
        "Not available",

      phone:
        details?.phone ||
        orderData?.notes?.phone ||
        parts[2] ||
        "Not available",

      country:
        details?.country ||
        orderData?.notes?.country ||
        parts[3] ||
        "Not available",

      countryCode:
        details?.country_code ||
        orderData?.notes?.countryCode ||
        parts[4] ||
        "Not available",

      timezone:
        details?.timezone ||
        orderData?.notes?.timezone ||
        "Not available",
    };
  };

  const formatISTDate = (date) => {
    if (!date) return "Not available";

    return new Date(date).toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  };

  const user = extractUser(order);

  const courseName =
    order?.notes?.course_title ||
    order?.notes?.course_name ||
    order?.notes?.product_name ||
    order?.notes?.title ||
    order?.product_id ||
    "Not available";

  return (
    <div className="w-full px-3 py-6 sm:px-4">
      <h1 className="text-3xl font-bold mb-6 text-gray-900">Order Details</h1>

      <div className="bg-white shadow-md rounded-xl p-5 mb-6 border border-gray-100">
        <div className="space-y-6">
          {/* Order Info */}
          <div>
            <h2 className="text-xl font-semibold mb-4 text-gray-900">
              Order Information
            </h2>

            <div className="space-y-3">
              <div className="break-words">
                <span className="font-semibold text-gray-800">Order ID: </span>
                <span className="text-gray-700 break-all">
                  {order?.order_id || "Not available"}
                </span>
              </div>

              <div className="break-words">
                <span className="font-semibold text-gray-800">Internal ID: </span>
                <span className="text-gray-700 break-all">
                  {order?._id || "Not available"}
                </span>
              </div>

              <div className="break-words">
                <span className="font-semibold text-gray-800">Date: </span>
                <span className="text-gray-700">
                  {formatISTDate(order?.createdAt)}
                </span>
              </div>

              <div className="break-words">
                <span className="font-semibold text-gray-800">Payment Method: </span>
                <span className="text-gray-700 break-words">
                  {order?.paymentMethod ||
                    order?.gateway ||
                    order?.notes?.gateway ||
                    "Not available"}
                </span>
              </div>

              <div className="break-words">
                <span className="font-semibold text-gray-800">Purchase Type: </span>
                <span className="text-gray-700">
                  {order?.purchase_type || "Not available"}
                </span>
              </div>

              <div className="break-words">
                <span className="font-semibold text-gray-800">Status: </span>
                <span
                  className={`inline-flex mt-1 px-3 py-1 rounded-lg text-sm font-semibold ${
                    order?.status === "captured" || order?.status === "paid"
                      ? "bg-green-100 text-green-700"
                      : "bg-red-100 text-red-700"
                  }`}
                >
                  {order?.status || "Not available"}
                </span>
              </div>
            </div>
          </div>

          {/* Customer Info */}
          <div className="border-t border-gray-100 pt-6">
            <h3 className="text-xl font-semibold mb-4 text-gray-900">
              Customer Information
            </h3>

            <div className="space-y-3">
              <div className="break-words">
                <span className="font-semibold text-gray-800">Name: </span>
                <span className="text-gray-700 break-words">{user.name}</span>
              </div>

              <div className="break-words">
                <span className="font-semibold text-gray-800">Email: </span>
                <span className="text-gray-700 break-all">{user.email}</span>
              </div>

              <div className="break-words">
                <span className="font-semibold text-gray-800">Phone: </span>
                <span className="text-gray-700 break-all">{user.phone}</span>
              </div>

              <div className="break-words">
                <span className="font-semibold text-gray-800">Country: </span>
                <span className="text-gray-700 break-words">{user.country}</span>
              </div>

              <div className="break-words">
                <span className="font-semibold text-gray-800">Country Code: </span>
                <span className="text-gray-700 break-words">
                  {user.countryCode}
                </span>
              </div>

              <div className="break-words">
                <span className="font-semibold text-gray-800">Timezone: </span>
                <span className="text-gray-700 break-words">{user.timezone}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Item Details */}
      <div className="bg-white shadow-md rounded-xl border border-gray-100 overflow-hidden">
        <div className="px-5 py-4 border-b border-gray-100">
          <h3 className="text-xl font-semibold text-gray-900">Order Item</h3>
        </div>

        <div className="p-5 space-y-4">
          <div className="break-words">
            <span className="font-semibold text-gray-800">Item: </span>
            <span className="text-gray-700 break-words">{courseName}</span>
          </div>

          <div className="break-words">
            <span className="font-semibold text-gray-800">Price: </span>
            <span className="text-gray-700">
              {order?.notes?.currency || "INR"} {order?.amount ?? "Not available"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderDetails;